import classnames from 'clsx';
import style from './divider.module.css';
import type { DividerProps, DividerOrientationValues } from './divider-types';

export const HORIZONTAL: DividerOrientationValues = 'horizontal';
export const VERTICAL: DividerOrientationValues = 'vertical';

/**
 * @deprecated Use `Divider` from `@mantine/core` instead.
 * See: ui-components/readme-documentation/MIGRATION.md
 */
export const Divider = ({ className, orientation = HORIZONTAL }: DividerProps): JSX.Element => {
  const isHorizontal = orientation === HORIZONTAL;

  return (
    <div
      className={classnames(
        style.divider,
        {
          [style.horizontal]: isHorizontal,
          [style.vertical]: !isHorizontal,
        },
        className,
      )}
    />
  );
};
